<div class="step-hint" *transloco="let t">
  <span class="step-hint__icon"><i [class]="icon()"></i></span>
  <p class="step-hint__text">{{ text() }}</p>
  <p-tag
    severity="success"
    icon="pi pi-gift"
    [value]="t('positioning.freeBadge')"
    styleClass="step-hint__badge" />
</div>
